/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { Interval, RequestStatus } from "~/constants";
import { ReportStatusEnum } from "~/features/reportTracker/constants";

export const NO_DATA_PLACEHOLDER_HEIGHT = 120;

export const TABLE_ROWS_PER_PAGE = 12;

export const TABLE_VISIBLE_PAGES = 5;

export const DEFAULT_FILTER_INTERVAL = Interval.TODAY;

export enum StatisticsGroupBy {
  DATE = "tm",
  TRACKING_ID = "trkid",
  REFERRER_ID = "refid",
  COUNTRY = "ctry",
  PLATFORM = "dev",
  PROCESSORID = "processorid",
}

export enum StatisticsPlatform {
  ALL = "",
  DESKTOP = "Desktop",
  MOBILE = "Mobile",
  TABLET = "Tablet",
  CONSOLE = "Console",
  SMART_TV = "Smart TV",
}

export enum StatisticsTab {
  TOTAL_STATS = "TOTAL_STATS",
  PLATFORM_STATS = "PLATFORM_STATS",
  USER_VALUE = "USER_VALUE",
  GEO = "GEO",
  UPSELL_STATS = "UPSELL_STATS",
  PAST_PAYOUTS = "PAST_PAYOUTS",
  USER_SPENDING = "USER_SPENDING",
  VIDEO_SALES = "VIDEO_SALES",
}

export const StatisticsTabList = [
  StatisticsTab.TOTAL_STATS,
  StatisticsTab.PLATFORM_STATS,
  StatisticsTab.USER_VALUE,
  StatisticsTab.GEO,
  StatisticsTab.UPSELL_STATS,
  StatisticsTab.PAST_PAYOUTS,
  StatisticsTab.USER_SPENDING,
  StatisticsTab.VIDEO_SALES,
] as const;

export enum StatisticsEmailSchedule {
  DAILY = "daily",
  WEEKLY = "weekly",
}

export enum StatisticsSubscribeStatus {
  ON = 1,
  OFF = 0,
}

export enum FormatType {
  MONEY = "money",
  PERCENTAGE = "percentage",
}

export const ReportTypeMappedByStatisticsTab = {
  TOTAL_STATS: "totalStats",
  PLATFORM_STATS: "platformStats",
  USER_VALUE: "userValue",
  GEO: "geo",
  UPSELL_STATS: "upsellStats",
  PAST_PAYOUTS: "pastPayouts",
  USER_SPENDING: "userSpending",
  VIDEO_SALES: "videoSales",
  DASHBOARD: "dashboard",
} as const;

export const RequestStatusMappedByReportStatus: Record<ReportStatusEnum, RequestStatus> = {
  [ReportStatusEnum.SUCCESS]: RequestStatus.SUCCESS,
  [ReportStatusEnum.PENDING]: RequestStatus.PENDING,
  [ReportStatusEnum.IDLE]: RequestStatus.IDLE,
  [ReportStatusEnum.FAILED]: RequestStatus.IDLE,
  [ReportStatusEnum.MARKED_FOR_DELETION]: RequestStatus.IDLE,
};
